// extracted by mini-css-extract-plugin
export default {"FormBuilderPage":"FormBuilderPage_FormBuilderPage__uyjK4","FormBuilderContainer":"FormBuilderPage_FormBuilderContainer__Cmgp1"};